import { useStore } from 'react-redux'

import { getFeatureFlags } from '~/selectors/feature-flags'

export default () => getFeatureFlags(useStore().getState())
